import moment from 'moment-timezone';

// Returns whether a scheduled variant's due date is still in the future
// (relative to the user's timezone). Returns null when there is no valid
// due date to evaluate. Shared by the QBank ExamView badge and the AI-chat
// question block so the "is this scheduled for later" rule can't drift.
export const isFutureScheduledVariant = (
  dueAt?: string | null,
  timezone?: string | null
) => {
  if (!dueAt) {
    return null;
  }

  const resolvedTimezone =
    timezone?.trim() || Intl.DateTimeFormat().resolvedOptions().timeZone;

  const scheduledMoment = resolvedTimezone
    ? moment.tz(dueAt, resolvedTimezone)
    : moment(dueAt);

  if (!scheduledMoment.isValid()) {
    return null;
  }

  return scheduledMoment.isAfter(moment());
};
